var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vlt-placeholder",style:(_vm.gridStyle)},_vm._l((_vm.numOfTimes),function(num,key){return _c('div',{key:key,staticClass:"vlt-div"},[_c('img',{class:_vm.orientation === 'LANDSCAPE' ? 'landscape':'potrait',attrs:{"src":_vm.orientation === 'LANDSCAPE' ? _vm.imageLandscape : _vm.imagePotrait,"alt":"placeholder-image"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }